export const SKILLS = [
  {
    id: "react",
    nameKey: "common.skills.react",
    icon: "/images/skills/react.png",
  },
  {
    id: "express",
    nameKey: "common.skills.express",
    icon: "/images/skills/express.png",
  },
  {
    id: "mongodb",
    nameKey: "common.skills.mongodb",
    icon: "/images/skills/mongodb.png",
  },
  {
    id: "nodejs",
    nameKey: "common.skills.nodejs",
    icon: "/images/skills/nodejs.png",
  },
  {
    id: "tailwind",
    nameKey: "common.skills.tailwind",
    icon: "/images/skills/tailwind.png",
  },
  {
    id: "i18n",
    nameKey: "common.skills.i18n",
    icon: "/images/skills/i18n.png",
  },
  {
    id: "framerMotion",
    nameKey: "common.skills.framerMotion",
    icon: "/images/skills/framer-motion.png",
  },
  {
    id: "javascript",
    nameKey: "common.skills.javascript",
    icon: "/images/skills/javascript.png",
  },
  {
    id: "nextjs",
    nameKey: "common.skills.nextjs",
    icon: "/images/skills/nextjs.png",
  },
  {
    id: "sass",
    nameKey: "common.skills.sass",
    icon: "/images/skills/sass.png",
  },
  {
    id: "mui",
    nameKey: "common.skills.mui",
    icon: "/images/skills/mui.png",
  },
  {
    id: "redux",
    nameKey: "common.skills.redux",
    icon: "/images/skills/redux1.png",
  },
  {
    id: "rtkQuery",
    nameKey: "common.skills.rtkQuery",
    icon: "/images/skills/rtk-query.png",
  },
  {
    id: "zustand",
    nameKey: "common.skills.zustand",
    icon: "/images/skills/zustand.png",
  },
  {
    id: "json",
    nameKey: "common.skills.json",
    icon: "/images/skills/json.png",
  },
  {
    id: "html",
    nameKey: "common.skills.html",
    icon: "/images/skills/html.png",
  },
  {
    id: "css",
    nameKey: "common.skills.css",
    icon: "/images/skills/css.png",
  },
  {
    id: "emailjs",
    nameKey: "common.skills.emailjs",
    icon: "/images/skills/emailjs.png",
  },
  {
    id: "npm",
    nameKey: "common.skills.npm",
    icon: "/images/skills/npm.png",
  },
  {
    id: "git",
    nameKey: "common.skills.git",
    icon: "/images/skills/git.png",
  },
  {
    id: "github",
    nameKey: "common.skills.github",
    icon: "/images/skills/github.png",
  },
  {
    id: "gitkraken",
    nameKey: "common.skills.gitkraken",
    icon: "/images/skills/gitkraken.png",
  },
  {
    id: "gitfork",
    nameKey: "common.skills.gitFork",
    icon: "/images/skills/gitfork.png",
  },
  {
    id: "figma",
    nameKey: "common.skills.figma",
    icon: "/images/skills/figma.png",
  },
  {
    id: "threejs",
    nameKey: "common.skills.threejs",
    icon: "/images/skills/threejs.png",
  },
  {
    id: "vite",
    nameKey: "common.skills.vite",
    icon: "/images/skills/vite.png",
  },
  {
    id: "tauri",
    nameKey: "common.skills.tauri",
    icon: "/images/skills/tauri.png",
  },
  {
    id: "itDiagnostics",
    nameKey: "common.skills.itDiagnostics",
    icon: "/images/skills/it-diagnostics.png",
  },
  {
    id: "pedagogy",
    nameKey: "common.skills.pedagogy",
    icon: "/images/skills/pedagogy.png",
  },
  {
    id: "solutionImplementation",
    nameKey: "common.skills.solutionImplementation",
    icon: "/images/skills/solution-implementation.png",
  },
  {
    id: "communication",
    nameKey: "common.skills.communication",
    icon: "/images/skills/communication.png",
  },
  {
    id: "hardwareAssistance",
    nameKey: "common.skills.hardwareAssistance",
    icon: "/images/skills/hardware-assistance.png",
  },
  {
    id: "softwareDeployment",
    nameKey: "common.skills.softwareDeployment",
    icon: "/images/skills/software-deployment.png",
  },
  {
    id: "systemAdministration",
    nameKey: "common.skills.systemAdministration",
    icon: "/images/skills/system-administration.png",
  },
  {
    id: "listeningSkills",
    nameKey: "common.skills.listeningSkills",
    icon: "/images/skills/listening-skills.png",
  },
  {
    id: "needsAnalysis",
    nameKey: "common.skills.needsAnalysis",
    icon: "/images/skills/needs-analysis.png",
  },
  {
    id: "supportAndTutoring",
    nameKey: "common.skills.supportAndTutoring",
    icon: "/images/skills/support-and-tutoring.png",
  },
  {
    id: "decisionMaking",
    nameKey: "common.skills.decisionMaking",
    icon: "/images/skills/decision-making.png",
  },
  {
    id: "animationTechniques",
    nameKey: "common.skills.animationTechniques",
    icon: "/images/skills/animation-techniques.png",
  },
  {
    id: "training",
    nameKey: "common.skills.training",
    icon: "/images/skills/training.png",
  },
  {
    id: "changeManagement",
    nameKey: "common.skills.changeManagement",
    icon: "/images/skills/change-management.png",
  },
  {
    id: "qualityControl",
    nameKey: "common.skills.qualityControl",
    icon: "/images/skills/quality-control.png",
  },
  {
    id: "processAnalysis",
    nameKey: "common.skills.processAnalysis",
    icon: "/images/skills/process-analysis.png",
  },
  {
    id: "electronicArchiving",
    nameKey: "common.skills.electronicArchiving",
    icon: "/images/skills/electronic-archiving.png",
  },
  {
    id: "clientFollowUp",
    nameKey: "common.skills.clientFollowUp",
    icon: "/images/skills/client-follow-up.png",
  },
  {
    id: "solutionSales",
    nameKey: "common.skills.solutionSales",
    icon: "/images/skills/solution-sales.png",
  },
  {
    id: "legalAssistance",
    nameKey: "common.skills.legalAssistance",
    icon: "/images/skills/legal-assistance.png",
  },
  {
    id: "organizationalSkills",
    nameKey: "common.skills.organizationalSkills",
    icon: "/images/skills/organizational-skills.png",
  },
  {
    id: "curiosity",
    nameKey: "common.skills.curiosity",
    icon: "/images/skills/curiosity.png",
  },
  {
    id: "rigor",
    nameKey: "common.skills.rigor",
    icon: "/images/skills/rigor.png",
  },
  {
    id: "adaptability",
    nameKey: "common.skills.adaptability",
    icon: "/images/skills/adaptability.png",
  },
  {
    id: "proactiveness",
    nameKey: "common.skills.proactiveness",
    icon: "/images/skills/proactiveness.png",
  },
  {
    id: "teamwork",
    nameKey: "common.skills.teamwork",
    icon: "/images/skills/teamwork1.png",
  },
  {
    id: "languageFR",
    nameKey: "common.skills.languageFR",
    icon: "/images/skills/language-fr.png",
  },
  {
    id: "languageEN",
    nameKey: "common.skills.languageEN",
    icon: "/images/skills/language-en.png",
  },
]

export const SOFTSKILLSLIST = SKILLS.filter((skill) =>
  [
    "communication",
    "decisionMaking",
    "teamwork",
    "proactiveness",
    "rigor",
    "adaptability",
    "curiosity",
  ].includes(skill.id)
)
